/**
 * Página de Envíos y Retiros
 * Información sobre métodos de entrega
 */

import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Chip,
  Stack,
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export default function ShippingPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <LocalShippingIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          Envíos y Retiros
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
          Elige la opción que mejor se adapte a tus necesidades
        </Typography>
      </Box>

      <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} sx={{ mb: 6 }}>
        {/* Delivery a domicilio */}
        <Box sx={{ flex: 1 }}>
          <Card sx={{ height: '100%', boxShadow: 3 }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <LocalShippingIcon sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
                <Typography variant="h4" fontWeight="bold">
                  Delivery a Domicilio
                </Typography>
              </Box>
              
              <Divider sx={{ mb: 3 }} />
              
              <List>
                <ListItem>
                  <ListItemIcon>
                    <AccessTimeIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Horarios de entrega"
                    secondary="Lunes a Sábado: 9:00 - 20:00 hrs | Domingo: 10:00 - 14:00 hrs"
                  />
                </ListItem>
                
                <ListItem>
                  <ListItemIcon>
                    <AttachMoneyIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Costo de envío"
                    secondary={
                      <>
                        <Chip label="$2.500" size="small" color="primary" sx={{ mr: 1 }} />
                        <Typography component="span" variant="body2">
                          GRATIS en compras sobre $30.000
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
                
                <ListItem>
                  <ListItemIcon>
                    <LocationOnIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Zonas de cobertura"
                    secondary="Radio de 5 km desde nuestro local - Consulta disponibilidad en tu zona"
                  />
                </ListItem>
                
                <ListItem>
                  <ListItemIcon>
                    <CheckCircleIcon color="success" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Tiempo de entrega"
                    secondary="Mismo día en pedidos antes de las 15:00 hrs"
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Box>

        {/* Retiro en tienda */}
        <Box sx={{ flex: 1 }}>
          <Card sx={{ height: '100%', boxShadow: 3 }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <StorefrontIcon sx={{ fontSize: 40, color: 'secondary.main', mr: 2 }} />
                <Typography variant="h4" fontWeight="bold">
                  Retiro en Tienda
                </Typography>
              </Box>
              
              <Divider sx={{ mb: 3 }} />
              
              <List>
                <ListItem>
                  <ListItemIcon>
                    <AccessTimeIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Horarios de retiro"
                    secondary="Lunes a Viernes: 9:00 - 19:00 hrs | Sábado: 9:00 - 14:00 hrs"
                  />
                </ListItem>
                
                <ListItem>
                  <ListItemIcon>
                    <AttachMoneyIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Costo"
                    secondary={
                      <Chip label="GRATIS" size="small" color="success" />
                    }
                  />
                </ListItem>
                
                <ListItem>
                  <ListItemIcon>
                    <LocationOnIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Dirección"
                    secondary="Av. Principal #123, Comuna, Región Metropolitana"
                  />
                </ListItem>
                
                <ListItem>
                  <ListItemIcon>
                    <CheckCircleIcon color="success" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Disponibilidad"
                    secondary="Tu pedido estará listo en 2-4 horas después de confirmado"
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Box>
      </Stack>

      {/* Información adicional */}
      <Paper sx={{ p: 4, bgcolor: 'grey.50' }}>
        <Typography variant="h5" gutterBottom fontWeight="bold" color="primary">
          Información Importante
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Confirmación de pedido"
              secondary="Recibirás un correo electrónico y SMS confirmando tu pedido y método de entrega"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Seguimiento"
              secondary="Podrás rastrear tu pedido en tiempo real desde tu cuenta"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Cambios y devoluciones"
              secondary="Tienes 24 horas para modificar o cancelar tu pedido sin costo adicional"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Productos refrigerados"
              secondary="Garantizamos la cadena de frío en todos nuestros envíos"
            />
          </ListItem>
        </List>
      </Paper>

      <Box sx={{ mt: 6, textAlign: 'center', p: 4, bgcolor: 'primary.light', borderRadius: 2 }}>
        <Typography variant="h6" fontWeight="bold" color="primary.contrastText" gutterBottom>
          ¿Necesitas ayuda?
        </Typography>
        <Typography variant="body1" color="primary.contrastText">
          Contáctanos al <strong>(+56) 9 1234 5678</strong> o escríbenos a <strong>contacto@abarrotes.cl</strong>
        </Typography>
      </Box>
    </Container>
  );
}
